import { FirebaseError } from 'firebase/app';

export function errorMessage(error: any) {
  if (error instanceof FirebaseError) {
    return 'An unexpected error occurred. Please try again later.';
  }

  return error.toString();
}
